import React, { useState } from "react";
import { Link, withRouter } from "react-router-dom";

const JobDescription = (props) => {
  const [showFullDescription, setShowFullDescription] = useState(false);
	const redirectBaseUrl = process.env['REACT_APP_ENV'] === 'dev' ? process.env['REACT_APP_JOBS_APP_BASE_URL'] : '';
	const openJob = () => {
		if(props.trafficType === "application_click"){
			window.open(props.jobURL);
		} else {
			window.open(props.jobURL);
			window.location = redirectBaseUrl+"/results/?OID=1313&&job="+props.jobTitle+"&location="+props.jobLocation+"&upkw=true"
		}
	}

  const toggleFullJobDescription = () => {
    showFullDescription ? setShowFullDescription(false) : setShowFullDescription(true);
  }

  const htmlTags = /<[^>]*>/g;
  const jobDescriptionMobile = showFullDescription ? props.jobDescription : props.jobDescription.replace(htmlTags, '').substring(0, 200) + '... ';
  const showHideFullJobDescriptionLinkCopy = showFullDescription ? "<< less" : "more >>"

	return (
		<section className="">
			<div className="jobContentWrapper">
				<div className="imageWrapper"><img src={props.jobLogo} alt="Logo" /></div>
				<div className="headingWrapper hasCompanyImage">
					<h2 className="jobTitle">{props.jobTitle}</h2>
					<h4 className="jobLocation">{props.jobCompany}</h4> <h4 className="jobLocation">{props.jobLocation}</h4>
					<h5 className="companyPostBot">{props.jobPosted}</h5>
				</div>
				<div className="applyButtonWrapper hidden-xs">
					<div className="visible-xs" id="bottomApplicationButtonWrapper">
						{
							(props.jobPage.toLowerCase() === "s" || props.trafficType === "application_click") ? (<button onClick={() => openJob()} className={` ${props.qs && props.qs.preview && props.qs.preview === "y" ? "d-none" : ""} btn btn-rounded btn-dark-blue`}>Apply Now</button>) :
							(<button onClick={() => props.setShowRegOverlay(true)} className={` ${props.qs && props.qs.preview && props.qs.preview === "y" ? "d-none" : ""} btn btn-rounded btn-dark-blue`}>Apply Now</button>)
						}
					</div>
				</div>
				<div className="clearfix" id="descriptionDetailWrapper">
					<div className="jobContentWrapper" >
						<div className="jobDesciptionWrapper">
							<h4>Job Description</h4>
							<div className="d-md-block d-none" dangerouslySetInnerHTML={{ __html: props.jobDescription }} />
							<div className="d-lg-none d-md-block" dangerouslySetInnerHTML={{ __html: jobDescriptionMobile }} /><br/><a className="d-lg-none d-md-block more-less-link" onClick={() => toggleFullJobDescription()}>{showHideFullJobDescriptionLinkCopy}</a>
						</div>
						<br/>
						<div className="clearfix d-none d-md-block">
							{
								(props.trafficType === "hosted" || props.trafficType === "hosted_plus" || props.trafficType === "") && props.jobPage === "8"
								? (<a onClick={() => props.setShowRegOverlay(true)}>See Full Description </a>)
								: (props.jobPage.toLowerCase() === "s" || props.trafficType === "application_click") ? (<a href="#" onClick={() => openJob()}>See Full Description </a>) : (<a href={props.jobURL} target="_blank">See Full Description </a>)
							}
						</div>
						<br className="d-none d-md-block"/>
						{((props.jobDetailsLocation !== "" && props.jobDetailsLocation !== undefined) || (props.jobEmpType !== "" && props.jobEmpType !== undefined) || (props.jobComp !== "" && props.jobComp !== undefined)) && <div className="jobDesciptionWrapper">
										<h4>Job Details</h4>
										{props.jobDetailsLocation !== "" && props.jobDetailsLocation !== undefined && <p><span style={{fontSize:"1.1em"}}>Location:</span>&nbsp; {props.jobDetailsLocation}</p>}
										{props.jobEmpType !== "" && props.jobEmpType !== undefined && <p><span style={{fontSize:"1.1em"}}>Employment Type:</span>&nbsp; {props.jobEmpType}</p>}
										{props.jobComp !== "" && props.jobComp !== undefined && <p><span style={{fontSize:"1.1em"}}>Compensation:</span>&nbsp; {props.jobComp}</p>}
									</div>}
					</div>
				</div>
			</div>
		</section>
	)
}

export default withRouter(JobDescription);
